import { CartProductDto, SaleUnitCartSplitDto, TableSplitRequestDto } from '@up/data';
import * as _ from 'lodash';

export function getSaleUnitCartSplitWithUnpaidAndNotVoidedProducts(
  tableSplitRequest: TableSplitRequestDto,
  cartProducts: CartProductDto[]
) {
  // Clone the split table
  const updatedSaleUnitCartSplit = _.cloneDeep(
    tableSplitRequest.saleUnitCartSplit
  ) as SaleUnitCartSplitDto;

  // Set the split table cart products from ALL unpaid and not voided cart products for the split table
  updatedSaleUnitCartSplit.cartProducts = cartProducts.filter(
    (x) =>
      !x.isPaid && !x.isVoid &&
      x?.saleUnitCartSplit?.id === tableSplitRequest.saleUnitCartSplit.id
  );

  return updatedSaleUnitCartSplit;
}